import Vue from 'vue';
import 'lib-flexible/flexible';
import { Lazyload, PullRefresh } from 'vant';
import { InfiniteScroll } from 'mint-ui';
import Vue2TouchEvents from 'vue2-touch-events';

import 'mint-ui/lib/style.css'
import './assets/css/normalize.css';
import './assets/css/common.css';
import App from './App.vue';
import router from './router';
import store from './store';
import echarts from 'echarts'
import { Table, TableColumn, Select, Option, Dropdown, DropdownMenu, DropdownItem}  from 'element-ui';
Vue.prototype.$echarts = echarts
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Lazyload,{
  lazyComponent: true
})
Vue.use(InfiniteScroll);
Vue.use(Vue2TouchEvents)
Vue.use(PullRefresh);
Vue.config.productionTip = false;
window.wm = new Vue({
  router,
  store,
  render: h => h(App),
  created(){
    window.jump = function (data) {
      this.$router.push({
        name:'message'
      })
    }
  }
}).$mount('#app');
